module.exports = __webpack_public_path__ + "img/react.9d281e03.svg";